var commonValidator = require('src/interlock/no-ui/validation/common');
// var blackListValidator = require('./blacklist');

var FIELDS_VALIDATORS = {
    firstName: {
        basic: commonValidator.validateName
        // blacklist: blackListValidator.validateName
    },
    lastName: {
        basic: commonValidator.validateName
        // blacklist: blackListValidator.validateName
    },
    phoneNumber: {
        basic: commonValidator.validatePhoneNumber,
        verification: commonValidator.verifyPhoneNumber
        // blacklist: blackListValidator.validatePhoneNumber
    },
    // LOP-47 AB Test removes verification step
    email: {
        basic: commonValidator.validateEmail
        //verification: commonValidator.verifyEmail
        // blacklist: blackListValidator.validateEmail
    }
};

module.exports = {
    'BASIC_VALIDATOR': 'basic',
    'VERIFICATION_VALIDATOR': 'verification',
    'BLACK_LIST': 'blacklist',
    'FIELDS_VALIDATORS': FIELDS_VALIDATORS
};


//////////////////
// WEBPACK FOOTER
// ./src/interlock/no-ui/validation/lead/constants-lop-47.js
// module id = 123
// module chunks = 0 1 16 19 21